export const categories = [
  {
    id: "entertainment",
    name: "娱乐风云",
    short: "娱乐",
    desc: "台前幕后的动态、合作变动与公开回应，梳理成可追溯的时间线。",
    icon: "ri-vip-crown-2-line",
    count: 128,
  },
  {
    id: "influencer",
    name: "网红观察",
    short: "网红",
    desc: "内容创作者与直播间里的风向变化，关注话题如何被放大与消化。",
    icon: "ri-live-line",
    count: 96,
  },
  {
    id: "screen",
    name: "影视综艺",
    short: "影视",
    desc: "剧集、电影与综艺的口碑走势、剪辑争议和幕后花絮整理。",
    icon: "ri-movie-2-line",
    count: 143,
  },
  {
    id: "music",
    name: "音乐现场",
    short: "音乐",
    desc: "音乐节、巡演与舞台直拍里的高光瞬间和现场细节复盘。",
    icon: "ri-music-2-line",
    count: 74,
  },
  {
    id: "esports",
    name: "电竞竞技",
    short: "电竞",
    desc: "战队阵容变动、赛事争议判罚与选手状态的持续跟进。",
    icon: "ri-gamepad-line",
    count: 61,
  },
  {
    id: "fashion",
    name: "时尚潮流",
    short: "时尚",
    desc: "红毯造型、街拍配色与品牌联名，用设计视角拆解细节。",
    icon: "ri-t-shirt-2-line",
    count: 52,
  },
];

export const articles = [
  {
    id: "a1",
    title: "剧组深夜路透流出，一处造型细节被网友逐帧放大分析",
    excerpt:
      "一组夜间拍摄现场的照片在社交平台流传，讨论焦点从剧情走向迅速转向造型细节，网友自发做了对比图与时间线。",
    category: "screen",
    categoryLabel: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20film%20set%20with%20warm%20amber%20spotlight%20and%20soft%20fog%2C%20abstract%20editorial%20photography%2C%20moody%20high%20contrast%20warm%20tones%2C%20no%20people%2C%20clean%20composition&width=900&height=600&seq=guatian-cover-01&orientation=landscape",
    tags: ["路透", "造型", "时间线"],
    author: "瓜田值日生",
    date: "2026-09-08",
    readTime: "6 分钟",
    heat: 9820,
    hot: true,
    deep: false,
    timeline: [
      { time: "23:40", event: "首批夜间现场照片出现在社交平台，未标注具体出处。" },
      { time: "00:15", event: "有网友整理出造型变化对比图，指出与已知设定存在差异。" },
      { time: "09:20", event: "讨论转向拍摄流程本身，多位从业者分享了剧组的常规操作。" },
      { time: "14:05", event: "相关内容热度回落，话题沉淀为一份可查阅的时间线整理。" },
    ],
    sources: ["公开社交平台内容整理", "从业者公开分享", "综合网友讨论"],
    content: [
      "一组拍摄现场的照片在深夜悄悄流出，最初只是几张模糊的路透图，谁也没想到会在第二天早上变成一次关于「细节」的集体复盘。照片里最吸引注意的并不是场景本身，而是角色造型上的一处变化——有网友把不同日期的现场图拼在一起，做成了对比表格。",
      "从对比图来看，造型在短短几天内出现了明显调整。有人认为这是剧情需要的阶段性变化，也有人觉得只是拍摄顺序与造型进度的正常错位。争论并没有停在情绪层面，反而带动了不少从业者出来科普：一部剧的拍摄周期里，造型、场景与镜头往往并不按最终播出顺序推进。",
      "我们把这轮讨论梳理成一条时间线，从最早的照片出现，到话题发酵，再到热度回落，尽量保留可核实的部分。需要说明的是，现场照片的出处多为未标注的转发，具体日期与拍摄顺序无法完全确认，因此本文不对剧情走向做任何推断。",
      "值得一提的是，这次讨论里最有价值的并不是猜测，而是一份被网友整理出来的「拍摄现场常识清单」：为什么造型会反复调整、为什么同一场戏要拍很多遍、为什么路透图总是与正片有差距。这些内容比单纯的猜测更耐读，也解释了为什么讨论最终会沉淀下来。",
    ],
  },
  {
    id: "a2",
    title: "音乐节后台花絮公开，一段即兴改编成了全场高光",
    excerpt:
      "主办方放出的后台记录片段里，乐手在候场时随手弹起的旋律，最终被完整搬上了正式舞台，成为当晚讨论度最高的段落。",
    category: "music",
    categoryLabel: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20music%20festival%20stage%20with%20warm%20amber%20and%20crimson%20lighting%2C%20silhouette%20of%20instruments%2C%20cinematic%20editorial%20photography%2C%20soft%20haze%2C%20clean%20composition&width=900&height=600&seq=guatian-cover-02&orientation=landscape",
    tags: ["音乐节", "现场", "即兴"],
    author: "现场观察员",
    date: "2026-09-07",
    readTime: "5 分钟",
    heat: 7640,
    hot: true,
    deep: false,
    timeline: [
      { time: "第 1 天", event: "主办方放出后台排练记录，其中一段即兴旋律被反复提及。" },
      { time: "第 2 天", event: "该旋律出现在正式演出中，现场观众反应热烈。" },
      { time: "第 3 天", event: "乐手在社交平台回应：改编来自候场时的临时起意。" },
    ],
    sources: ["主办方公开影像", "现场观众分享", "乐手公开回应"],
    content: [
      "音乐节的后台总有些不在计划里的瞬间。这次被记录下来的，是一段几乎被忽略的候场旋律：乐手在等出场时随口弹起几个和弦，被随行的工作人员拍了下来，后来剪进了官方发布的花絮短片里。",
      "真正让这段旋律出圈的，是它出现在正式演出中的那一刻。改编后的版本被放进了第三首歌的间奏，旋律线更完整，配器也更克制。现场观众几乎是立刻认出了它的来源，掌声在间奏结束后持续了很久。",
      "乐手随后在社交平台做了简短回应：这段改编并非事先设计，而是候场时顺手弹起的片段，排练时觉得合适就保留了下来。这样的坦白反而让讨论更友好，评论区里更多是在分享各自在现场听到这首歌时的感受。",
      "从传播角度看，这段花絮之所以能成为高光，是因为它保留了创作过程里最真实的部分——不完美的尝试、临时的决定，以及被现场观众验证的那一刻。比起精心剪辑的宣传片，这种带点毛边的记录更容易被记住。",
    ],
  },
  {
    id: "a3",
    title: "综艺剪辑节奏引讨论，未播片段被网友拼出完整时间线",
    excerpt:
      "节目播出后，有观众发现片段顺序与现场记录并不一致，随后自发整理了对照表，讨论逐渐从情绪转向对剪辑逻辑的理解。",
    category: "screen",
    categoryLabel: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20television%20studio%20with%20warm%20amber%20and%20muted%20green%20lighting%2C%20rows%20of%20soft%20lights%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20clean%20minimal%20composition&width=900&height=600&seq=guatian-cover-03&orientation=landscape",
    tags: ["综艺", "剪辑", "时间线"],
    author: "瓜田值日生",
    date: "2026-09-06",
    readTime: "7 分钟",
    heat: 6890,
    hot: true,
    deep: false,
    timeline: [
      { time: "播出当晚", event: "有观众在评论区指出某段落的顺序与现场描述不一致。" },
      { time: "次日中午", event: "网友整理出未播片段与正片的对照表。" },
      { time: "第三日", event: "节目组在官方账号说明了剪辑的基本逻辑。" },
    ],
    sources: ["节目正片", "节目组公开说明", "现场观众描述整理"],
    content: [
      "一档户外真人秀播出后，最先引起注意的并不是任务本身，而是片段之间的衔接方式。有观众对照现场分享的记录，发现部分环节的呈现顺序与拍摄时的实际情况存在差别，于是把能确认的信息整理成了一张对照表。",
      "这张对照表的价值在于它把讨论从「谁被剪掉了」拉回到「为什么要这样剪」。综艺节目的叙事需要节奏，镜头取舍往往服务于当期主题。当观众理解了这一点，讨论的情绪就明显缓和了下来。",
      "节目组随后也做了公开说明，解释了当期剪辑围绕一条主线展开，部分环节因为时长限制被放进了加更内容。这种回应方式让信息更透明，也让对照表有了官方的补充版本。",
      "这件事给出的启示其实很朴素：在信息不完整的时候，猜测比理解跑得更快。而一份愿意标注来源、承认不确定性的整理，才是真正能让讨论继续下去的东西。",
    ],
  },
  {
    id: "a4",
    title: "短剧演员转向长剧，首播口碑出现两种完全不同的声音",
    excerpt:
      "从竖屏短剧走进长剧集，节奏与表演方式都要重新适应。首播后，赞誉与质疑几乎同时出现，讨论集中在表演尺度上。",
    category: "entertainment",
    categoryLabel: "娱乐风云",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20cinema%20screen%20glow%20with%20warm%20amber%20and%20deep%20crimson%20tones%2C%20soft%20bokeh%20lights%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20minimal%20composition&width=900&height=600&seq=guatian-cover-04&orientation=landscape",
    tags: ["短剧", "转型", "口碑"],
    author: "观剧笔记",
    date: "2026-09-05",
    readTime: "6 分钟",
    heat: 6120,
    hot: false,
    deep: false,
    timeline: [
      { time: "首播日", event: "长剧首播，弹幕中关于表演节奏的讨论集中出现。" },
      { time: "次日", event: "多位评论者从短剧与长剧的节奏差异切入分析。" },
      { time: "第三日", event: "讨论从个人转向行业现象，话题趋于理性。" },
    ],
    sources: ["长剧首播内容", "公开剧评", "从业者公开访谈"],
    content: [
      "短剧与长剧的差别，远不只是时长。竖屏短剧习惯在极短时间内完成情绪推进，而长剧需要留白、需要铺陈，这对表演尺度提出了完全不同的要求。一位长期活跃在短剧里的演员首次挑大梁主演长剧，首播后的评价自然分成了两派。",
      "支持的一方认为，演员把短剧里那种利落的情绪很自然地延续了下来，处理日常戏份时反而显得清爽；质疑的一方则觉得，某些需要层次的地方推进得太快，观众来不及跟上。两种意见其实指向了同一件事：节奏的适配。",
      "有评论者从行业角度做了补充，指出短剧出身并不意味着演技不够，而是创作环境与训练方式不同。转型需要一个过程，也需要更合适的剧本去承接。这样的分析比简单的好坏评价更有参考价值。",
      "接下来的几集或许更能说明问题。对于观众来说，与其在第一周就下结论，不如把关注点放在演员如何逐渐找到属于自己的节奏上。",
    ],
  },
  {
    id: "a5",
    title: "电竞战队阵容调整引热议，教练组回应称仍在磨合期",
    excerpt:
      "赛季中段的阵容变动让粉丝措手不及，官方以一份简短说明回应，强调调整基于训练数据而非临时决定。",
    category: "esports",
    categoryLabel: "电竞竞技",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20esports%20arena%20with%20warm%20amber%20and%20teal%20stage%20lighting%2C%20empty%20player%20desks%2C%20cinematic%20editorial%20photography%2C%20soft%20haze%2C%20minimal%20composition&width=900&height=600&seq=guatian-cover-05&orientation=landscape",
    tags: ["电竞", "阵容", "磨合"],
    author: "赛场记录者",
    date: "2026-09-04",
    readTime: "5 分钟",
    heat: 5480,
    hot: false,
    deep: false,
    timeline: [
      { time: "周二", event: "战队公布阵容调整名单，引发粉丝集中讨论。" },
      { time: "周三", event: "教练组发布说明，解释调整依据训练数据。" },
      { time: "周五", event: "新阵容首场比赛结束，评价趋于客观。" },
    ],
    sources: ["战队官方公告", "赛事公开数据", "教练组公开说明"],
    content: [
      "赛季进行到中段，任何阵容变动都容易被放大。这支战队在周二公布的调整名单并不算大，却因为涉及核心位置而迅速成为话题。粉丝的第一反应可以理解：临时换人往往意味着不确定性。",
      "教练组随后发布的说明提供了另一种视角。文中提到，调整的讨论从赛季初就在进行，依据的是训练赛数据与选手状态曲线，而非某一场失利带来的情绪决策。这份说明没有回避问题，也承认新阵容需要磨合。",
      "周五的首场比赛成为了第一份答卷。新阵容配合上还有生涩的地方，但整体节奏比预期稳定。赛后评论开始从「该不该换」转向「还需要多久才能磨合好」，这本身就是讨论走向成熟的信号。",
      "竞技体育与电竞在这一点上很像：阵容调整永远伴随风险，而判断的依据应该来自足够多的样本，而不是一场比赛的结果。",
    ],
  },
  {
    id: "a6",
    title: "时尚周街拍合集释出，一组复古配色意外成为主流选择",
    excerpt:
      "本季街拍里，低饱和的焦糖色与橄榄绿反复出现，造型师们不约而同地选择了更克制的搭配逻辑。",
    category: "fashion",
    categoryLabel: "时尚潮流",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20fashion%20week%20runway%20with%20warm%20caramel%20and%20olive%20green%20tones%2C%20soft%20spotlights%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20elegant%20minimal%20composition&width=900&height=600&seq=guatian-cover-06&orientation=landscape",
    tags: ["街拍", "配色", "复古"],
    author: "造型观察",
    date: "2026-09-03",
    readTime: "4 分钟",
    heat: 4730,
    hot: false,
    deep: false,
    timeline: [
      { time: "第 1 日", event: "首批街拍释出，焦糖色外套出现频率明显偏高。" },
      { time: "第 3 日", event: "橄榄绿单品成为第二高频选择，搭配逻辑趋同。" },
      { time: "收官日", event: "媒体整理出本季街拍配色趋势报告。" },
    ],
    sources: ["公开街拍影像", "造型师公开采访", "媒体趋势整理"],
    content: [
      "街拍最有意思的地方在于它的「巧合」——当不同城市的造型师在互不通气的情况下做出相似选择时，往往意味着某种审美共识正在形成。本季街拍里，焦糖色与橄榄绿几乎同时出现，构成了一个相当统一的低饱和色板。",
      "与上一季的高饱和撞色不同，这次的关键词是克制。外套多为焦糖、驼色，内搭则偏向橄榄绿与米白，整体层次由材质而非颜色区分。造型师在采访中提到，这种搭配更适合日常通勤场景的延展。",
      "值得注意的是配饰的处理。本季街拍里，金属配饰明显减少，取而代之的是深棕皮革与哑光质地的小面积点缀，视觉重心被重新拉回服装本身的廓形。",
      "趋势报告给出的结论很直接：低饱和暖色系将在接下来的季节里继续存在。至于它会不会演变成新一轮的主流，还需要观察下一季的街拍样本。",
    ],
  },
  {
    id: "a7",
    title: "悬疑剧结局疑似被提前讨论，平台方说明正在排查内容源",
    excerpt:
      "临近收官，社交平台出现大量指向结局的讨论。平台随后发布说明，表示将对非官方内容源进行核查。",
    category: "screen",
    categoryLabel: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20suspense%20scene%20with%20warm%20amber%20single%20light%20and%20deep%20shadows%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20tense%20minimal%20composition&width=900&height=600&seq=guatian-cover-07&orientation=landscape",
    tags: ["悬疑", "结局", "内容源"],
    author: "观剧笔记",
    date: "2026-09-02",
    readTime: "5 分钟",
    heat: 8210,
    hot: true,
    deep: true,
    timeline: [
      { time: "周一", event: "社交平台出现大量指向结局的讨论帖。" },
      { time: "周二", event: "平台方发布说明，称正在核查非官方内容源。" },
      { time: "周四", event: "收官集照常播出，相关讨论热度下降。" },
    ],
    sources: ["平台方公开说明", "剧集官方账号", "综合网友讨论"],
    content: [
      "悬疑剧的收官周向来最敏感。这一轮讨论的起点是社交平台上突然增多的话题帖，其中不少直接指向结局走向。对于追剧的观众来说，这种信息既让人好奇，也容易破坏观剧体验。",
      "平台方随后发布了一份简短的说明，表示已经注意到相关讨论，正在对非官方内容源的传播路径进行核查，并呼吁观众通过官方渠道观看。说明没有透露更多细节，态度相对克制。",
      "从观众的反应来看，多数人对平台的处理方式是理解的态度。真正让讨论失控的往往不是剧透本身，而是真假混杂的猜测——当无法确认信息真伪时，观众反而更焦虑。",
      "收官集最终照常播出。回头来看，这轮风波留下的经验是：面对未经确认的内容，保持一点耐心，本身就是对创作的一种尊重。",
    ],
  },
  {
    id: "a8",
    title: "独立乐队巡演临时加场，票务机制调整后获得不少好评",
    excerpt:
      "原定场次售罄后，乐队宣布加开一场，并同步调整了购票规则，实名限购成为讨论焦点。",
    category: "music",
    categoryLabel: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20live%20music%20venue%20with%20warm%20amber%20string%20lights%20and%20deep%20olive%20shadows%2C%20empty%20stage%2C%20cinematic%20editorial%20photography%2C%20cozy%20minimal%20composition&width=900&height=600&seq=guatian-cover-08&orientation=landscape",
    tags: ["巡演", "票务", "加场"],
    author: "现场观察员",
    date: "2026-09-01",
    readTime: "4 分钟",
    heat: 3960,
    hot: false,
    deep: false,
    timeline: [
      { time: "首轮开票", event: "原定场次短时间内售罄。" },
      { time: "次日", event: "乐队宣布加开一场，并启用实名限购规则。" },
      { time: "加场开票", event: "购票流程顺畅，观众反馈明显改善。" },
    ],
    sources: ["乐队官方公告", "票务平台公开规则", "观众公开反馈"],
    content: [
      "独立乐队的巡演往往规模不大，正因如此，热门场次售罄后的抢票体验格外让人在意。这支乐队原定场次开票即售罄，随后宣布加开一场，同时调整了购票规则。",
      "新的规则里，实名限购是最受关注的一条：每位购票者对应一张票，入场时需核验身份。对习惯了抢票的观众来说，这反而让流程变得更清晰——不用担心秒空的焦虑，也不用反复刷新页面。",
      "加场开票当天，购票体验的反馈明显好于首轮。有观众在社交平台表示，虽然规则更严格，但「抢得到」这件事本身就足够让人安心。",
      "票务机制的调整未必能解决所有问题，但它至少说明了一件事：当主办方愿意在规则上多花一点心思，观众的体验是可以被改善的。",
    ],
  },
  {
    id: "a9",
    title: "直播带货选品标准被公开讨论，从业者分享了一套自查清单",
    excerpt:
      "一位从业者在社交平台分享了自己的选品自查清单，从资质到售后逐条梳理，引发了同行间的经验交流。",
    category: "influencer",
    categoryLabel: "网红观察",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20live%20streaming%20studio%20with%20warm%20amber%20ring%20light%20and%20muted%20green%20background%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20clean%20minimal%20composition&width=900&height=600&seq=guatian-cover-09&orientation=landscape",
    tags: ["直播", "选品", "清单"],
    author: "内容观察",
    date: "2026-08-31",
    readTime: "6 分钟",
    heat: 4310,
    hot: false,
    deep: true,
    timeline: [
      { time: "周一", event: "从业者公开分享选品自查清单。" },
      { time: "周三", event: "多位同行在评论区补充了自己的经验条目。" },
      { time: "周末", event: "清单被整理成公开文档，供从业者参考。" },
    ],
    sources: ["从业者公开分享", "评论区经验补充", "综合整理"],
    content: [
      "直播带货早已不是新鲜事，但选品这件事依然缺少统一的标准。一位从业者最近在社交平台分享了自己的自查清单，条目不复杂，却覆盖了从资质到售后的完整链路。",
      "清单的第一部分是资质核查：产品类别对应的许可证、检验报告以及有效期，都是必须逐项确认的内容。第二部分则关注信息一致性——口播描述、商品页面与实物是否匹配，是很多售后问题的源头。",
      "清单的第三部分最容易被忽略：售后预案。从业者建议在开播前就明确退换货流程与响应时效，避免问题在直播间里被临时处理。这条建议在评论区获得了最多的认同。",
      "这份清单的价值不在于它有多完整，而在于它把「经验」变成了可复用的步骤。当越来越多从业者愿意公开自己的方法，行业的整体水位自然会被抬升。",
    ],
  },
  {
    id: "a10",
    title: "新一季剧集官宣阵容，配角班底成为讨论度最高的部分",
    excerpt:
      "官方公布主演阵容后，讨论焦点意外落在配角名单上，几位长期活跃在舞台剧的演员获得了大量关注。",
    category: "entertainment",
    categoryLabel: "娱乐风云",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20theatre%20stage%20with%20warm%20amber%20curtain%20and%20soft%20spotlight%2C%20empty%20stage%2C%20cinematic%20editorial%20photography%2C%20elegant%20minimal%20composition&width=900&height=600&seq=guatian-cover-10&orientation=landscape",
    tags: ["官宣", "阵容", "配角"],
    author: "瓜田值日生",
    date: "2026-08-30",
    readTime: "5 分钟",
    heat: 5670,
    hot: false,
    deep: false,
    timeline: [
      { time: "上午", event: "剧集官方公布主演阵容。" },
      { time: "下午", event: "配角名单释出，讨论度迅速超过主演。" },
      { time: "次日", event: "媒体整理了几位配角的舞台剧履历。" },
    ],
    sources: ["剧集官方账号", "演员公开履历", "媒体公开报道"],
    content: [
      "一部新剧官宣阵容，通常主演是最大的话题。但这一次，讨论的重心在配角名单公布后发生了转移。几位长期活跃在舞台剧舞台上的演员出现在名单里，让不少观众感到惊喜。",
      "舞台剧出身意味着什么？对演员来说，是长期在固定场地里反复打磨同一段表演，对节奏和细节的把控会格外扎实。这种训练方式与影视拍摄完全不同，而观众显然对这样的背景充满期待。",
      "有媒体随后整理了几位演员的公开履历，发现他们大多在剧场里积累了相当数量的作品。这些履历平时不常被讨论，却在此刻成为了最有说服力的注脚。",
      "阵容讨论本身并不能决定成片质量，但它至少说明：当制作方愿意在配角上投入心思，观众的期待也会更认真地回应。",
    ],
  },
  {
    id: "a11",
    title: "赛场判罚争议持续发酵，赛事方发布逐步回放说明流程",
    excerpt:
      "一场焦点赛事的判罚引发了持续讨论，赛事方罕见地公开了回放判定流程，试图让争议回到规则本身。",
    category: "esports",
    categoryLabel: "电竞竞技",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20sports%20arena%20scoreboard%20with%20warm%20amber%20and%20muted%20green%20lighting%2C%20empty%20court%2C%20cinematic%20editorial%20photography%2C%20clean%20minimal%20composition&width=900&height=600&seq=guatian-cover-11&orientation=landscape",
    tags: ["判罚", "规则", "回放"],
    author: "赛场记录者",
    date: "2026-08-29",
    readTime: "6 分钟",
    heat: 5020,
    hot: false,
    deep: true,
    timeline: [
      { time: "比赛结束", event: "争议判罚成为赛后讨论焦点。" },
      { time: "次日", event: "赛事方公开回放判定流程说明。" },
      { time: "第三日", event: "多个战队教练公开表示理解判定依据。" },
    ],
    sources: ["赛事方公开说明", "比赛回放影像", "教练公开表态"],
    content: [
      "焦点赛事的判罚争议几乎是每个赛季都会出现的课题。这一次的讨论之所以没有持续失控，很大程度上归功于赛事方在第二天就公开了完整的判定流程说明。",
      "说明里没有回避争议点，而是把回放查看的每一步都列了出来：由哪一方发起、查看了哪些角度、依据了哪条规则、最终如何得出结论。这种透明化的处理方式，让讨论有了共同的参照点。",
      "值得注意的是，多位战队教练在后续的公开表态里都提到了同一个词——「可预期」。规则的价值不仅在于判罚本身，更在于让所有参与者都能提前预见结果的走向。",
      "争议不会因为一份说明就消失，但它至少把焦点从情绪拉回了规则。对于一项不断成长的电竞赛事来说，这或许是比单场胜负更重要的事。",
    ],
  },
  {
    id: "a12",
    title: "品牌联名系列细节曝光，设计稿里的一处巧思被反复提及",
    excerpt:
      "联名系列的实物细节陆续公开，其中一处藏在袖口的设计让不少收藏者直呼意外。",
    category: "fashion",
    categoryLabel: "时尚潮流",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20fashion%20studio%20flatlay%20with%20warm%20caramel%20fabric%20and%20olive%20accent%2C%20soft%20natural%20light%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20elegant%20minimal%20composition&width=900&height=600&seq=guatian-cover-12&orientation=landscape",
    tags: ["联名", "设计", "细节"],
    author: "造型观察",
    date: "2026-08-28",
    readTime: "4 分钟",
    heat: 3480,
    hot: false,
    deep: false,
    timeline: [
      { time: "预热期", event: "品牌放出设计稿局部，引发猜测。" },
      { time: "发售前", event: "实物细节曝光，袖口设计成为焦点。" },
      { time: "发售后", event: "收藏者分享实物细节，讨论转向设计语言。" },
    ],
    sources: ["品牌官方发布", "实物细节分享", "综合整理"],
    content: [
      "品牌联名最怕的是「贴标」，而这一系列显然不打算这么做。从预热期的设计稿开始，官方就只放出了局部图，留下足够多的悬念，直到实物细节陆续公开，讨论才真正热了起来。",
      "被反复提及的是一处藏在袖口的设计：内衬的颜色与外层形成低饱和的对比，只有在卷起袖口时才能看到。这样的处理不张扬，却让整件单品的完成度提升了一个层次。",
      "收藏者的反馈也很直接——他们更在意设计语言是否连贯，而非联名标识是否醒目。当细节经得起推敲，系列本身就具备了超越一次发售的讨论价值。",
      "从设计角度看，这一系列延续了品牌近年的克制风格。无论是配色还是工艺，都没有为了话题而妥协，这也是它能在社交平台获得好评的原因。",
    ],
  },
];

export const faqs = [
  {
    q: "看料吃瓜社的内容主要来自哪里？",
    a: "站内内容来自公开社交平台、官方账号发布的信息，以及网友投稿结合公开资料的整理。我们会在每篇瓜料末尾标注可核实的信息来源，对于无法确认的部分会明确说明，不做主观推断。",
  },
  {
    q: "网站的瓜料多久更新一次？",
    a: "热门大瓜与劲爆猛料板块通常在工作日每天更新，深水硬核的长线整理内容更新频率稍低，一般每周集中整理一到两次。遇到热议事件时，我们会优先补充时间线。",
  },
  {
    q: "我想投稿一条线索，应该怎么操作？",
    a: "可以通过「联系我们」页面的线索投稿表单提交，尽量写明事件大致时间、涉及的信息来源以及可供核实的公开链接。我们会先做基础核实，再决定是否整理发布。",
  },
  {
    q: "网站上的内容都会标注来源吗？",
    a: "会的。我们坚持让每条整理都有出处可查，涉及公开影像或账号发言时会注明平台类型，涉及从业者分享时会说明其为公开表态。这是站点内容原则的一部分。",
  },
  {
    q: "浏览看料吃瓜社的内容需要付费吗？",
    a: "目前站内所有瓜料、专题与时间线整理均免费开放浏览，无需注册。后续若推出更系统的深度内容，会在站点内提前说明，不会影响现有内容的访问。",
  },
  {
    q: "发现内容有误，如何反馈更正？",
    a: "欢迎通过联系表单提交更正说明，写明需要更正的段落与依据。核实后我们会尽快修订，并在页面底部标注更新记录，保证信息可追溯。",
  },
];

export const testimonials = [
  {
    name: "阿泽",
    role: "追热点的人",
    text: "最满意的是时间线整理，事件来龙去脉一目了然，不用自己在时间线里翻半天。",
  },
  {
    name: "小满",
    role: "内容编辑",
    text: "标注来源这点很加分。做二次整理的时候，能直接顺着出处核对，省了很多时间。",
  },
  {
    name: "老周",
    role: "签约作者",
    text: "分类分得很清楚，影视和音乐分开看，找选题的时候很顺手，页面也不吵。",
  },
  {
    name: "林一",
    role: "普通读者",
    text: "更新挺勤的，热榜没有那种标题党味道，读起来反而更舒服。",
  },
];

export const stats = [
  { label: "累计整理瓜料", value: "1,286", unit: "条" },
  { label: "分类内容线", value: "6", unit: "条" },
  { label: "每日更新", value: "20+", unit: "条" },
  { label: "来源可追溯率", value: "97", unit: "%" },
];